<ion-header mode="ios">
  <ion-toolbar>
    <ion-title>{{ 'pages.fund-cash.detail.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ui-current-cdc [project]="project" [showRole]="false"></ui-current-cdc>
</ion-header>

<ion-content class="ion-padding">
  <ion-card class="purchase-card ion-margin-bottom" *ngIf="cashFund$ | async; let cashFund">
    <ion-card-content>
      <ui-fund-cash-status-badge [purchase]="cashFund"></ui-fund-cash-status-badge>
      <h2 class="item-title">{{ cashFund.article?.description }}</h2>

      <div class="item-tags">
        <ion-icon name="pricetag"></ion-icon>
        <span>{{ cashFund.article?.description }} ({{ cashFund.taskName }}/{{ cashFund.subtask?.name }})</span>
      </div>

      <div
        *ngIf="
          cashFund.transferStatus !== null &&
          cashFund.transferStatus !== TransferStatusEnum.None &&
          cashFund.assignedUser?.id !== identity.id
        "
        class="transfer-info"
      >
        {{
          'pages.fund-cash.detail.transferredTo'
            | translate
              : {
                  transferrerName: cashFund.createdUser?.name,
                  date: cashFund.createdDate | date: 'dd/MM/YYYY',
                  time: cashFund.createdDate | date: 'HH:mm',
                  transfereeName: cashFund.assignedUser?.name
                }
        }}
      </div>

      <div class="totals" [class.has-no-authorization-and-payment]="!cashFund.isAuthorized && !cashFund.isPaid">
        <ui-fund-cash-payment-status-badge
          class="status-badge"
          [isPaid]="cashFund.isPaid ?? false"
          [isAuthorized]="cashFund.isAuthorized ?? false"
        >
        </ui-fund-cash-payment-status-badge>

        <div *ngIf="cashFund.isAuthorized">
          <div class="total-label">
            {{ 'pages.fund-cash.purchase.confirm.info.totalAuthorized' | translate }}
            <strong>{{ cashFund.authorizedAmount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
          </div>
          <div class="date">
            {{ cashFund.authorizationDate | date: 'dd/MM/YYYY, HH:mm' }}
          </div>
        </div>

        <div *ngIf="cashFund.isPaid">
          <div class="total-label">
            {{ 'pages.fund-cash.purchase.confirm.info.totalPayment' | translate }}
            <strong>{{ cashFund.paymentAmount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
          </div>
          <div class="date">
            {{ cashFund.paymentDate | date: 'dd/MM/YYYY, HH:mm' }}
          </div>
        </div>
      </div>

      <div class="meta">
        <div>{{ cashFund.merchantName }}</div>
      </div>
    </ion-card-content>
  </ion-card>

  <form id="fund-cash-send-form" [formGroup]="form">
    <div class="cashfund-purchase-document">
      <div class="purchase-document-header">
        <span class="font-medium ion-text-uppercase">
          {{ 'pages.fund-cash.detail.documents.label' | translate }}
        </span>

        <ion-segment class="purchase-document-segment" mode="md" [value]="purchaseDocumentType">
          <ion-segment-button [value]="PurchaseDocumentType.RECEIPT">
            <ion-label>{{ 'pages.fund-cash.detail.documents.receipt' | translate }}</ion-label>
          </ion-segment-button>
          <ion-segment-button [value]="PurchaseDocumentType.INVOICE">
            <ion-label>{{ 'pages.fund-cash.detail.documents.invoice' | translate }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>

      <ui-file-input
        [readonly]="true"
        [value]="purchaseDocumentAttachment"
        label="pages.fund-cash.detail.documents.attach"
        (openPreviewEvent)="openAttachment($event)"
      ></ui-file-input>
    </div>
  </form>

  <ui-form-field [control]="form.controls.notes" label="pages.fund-cash.purchase.confirm.notes" class="fs-16" data-cy="Notes">
    <ion-textarea [formControl]="form.controls.notes" [autoGrow]="true" [rows]="1" [readonly]="true"></ion-textarea>
  </ui-form-field>

  <div class="font-medium block ion-text-uppercase cashfund-other-attachments-title">
    {{ 'pages.fund-cash.detail.documents.otherAttachmentsLabel' | translate }}
  </div>

  <div class="cashfund-other-attachments">
    <div class="file-col" *ngIf="shouldShowOtherAttachment(0)">
      <ui-file-input
        [readonly]="true"
        [value]="getOtherAttachment(0)"
        label="pages.fund-cash.detail.documents.otherAttachment"
        (openPreviewEvent)="openAttachment($event)"
      ></ui-file-input>
    </div>
    <div class="file-col" *ngIf="shouldShowOtherAttachment(1)">
      <ui-file-input
        [readonly]="true"
        [value]="getOtherAttachment(1)"
        label="pages.fund-cash.detail.documents.otherAttachment"
        (openPreviewEvent)="openAttachment($event)"
      ></ui-file-input>
    </div>
    <div class="file-col" *ngIf="shouldShowOtherAttachment(2)">
      <ui-file-input
        [readonly]="true"
        [value]="getOtherAttachment(2)"
        label="pages.fund-cash.detail.documents.otherAttachment"
        (openPreviewEvent)="openAttachment($event)"
      ></ui-file-input>
    </div>
    <div class="file-col" *ngIf="shouldShowOtherAttachment(3)">
      <ui-file-input
        [readonly]="true"
        [value]="getOtherAttachment(3)"
        label="pages.fund-cash.detail.documents.otherAttachment"
        (openPreviewEvent)="openAttachment($event)"
      ></ui-file-input>
    </div>
  </div>
</ion-content>
